import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {numberToCurrency, sleep} from 'src/smoothr-web-app-core/utils/utils';
import {RepositoryService} from "../../../smoothr-web-app-core/services/repository/repository.service";
import {OrderUtils} from "../../../smoothr-web-app-core/utils/order-utils";
import {CheckoutModalComponent} from "../checkout-modal/checkout-modal.component";
import RepositoryInterface from "../../../smoothr-web-app-core/directives/repository-directive";
import {NavigationService} from "../../services/navigation.service";
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
    applyExtrasToOrder,
    buildExtrasSelection,
    EXTRAS_MAX_QUANTITY,
    ExtraSelection,
    extrasTotalPrice
} from "../../helpers/extras-functions";

@Component({
    selector: 'app-order-content-modal',
    templateUrl: './order-content-modal.component.html',
    styleUrls: ['./order-content-modal.component.scss'],
})
export class OrderContentModalComponent extends RepositoryInterface implements OnInit {
    @ViewChild('swiper', {static: false}) swiperEl: ElementRef;

    tip = 0;
    loading = false;
    extras: ExtraSelection[] = [];
    total = 0;
    personCount: number = null;

    constructor(private modalCtrl: ModalController,
                public repo: RepositoryService,
                public translate: TranslateService,
                private snackbarCtrl: MatSnackBar,
                private navigationService: NavigationService) {
        super(repo);
    }

    static async presentModal(modalCtrl: ModalController) {
        console.log(modalCtrl);
        const modal = await modalCtrl.create({
            component: OrderContentModalComponent,
            backdropDismiss: true,
            showBackdrop: true,
            cssClass: 'menu-modal',
        });
        await modal.present();
        await sleep(200);
        return await modal.onDidDismiss();
    }

    nextSlide() {
        this.extras = buildExtrasSelection(this.repo._venue, this.repo._order);
        this.updateTotal();
        this.swiperEl.nativeElement.swiper.slideNext()
    }

    onPersonCountChange(value: number) {
        const personCount = Math.trunc(Number(value));
        if (!personCount || personCount < 1) {
            return;
        }
        this.setExtrasQuantity(Math.min(personCount, EXTRAS_MAX_QUANTITY));
    }

    setExtrasQuantity(quantity: number) {
        this.extras.forEach(extra => (extra.quantity = quantity));
        this.updateTotal();
    }

    remove(extra: ExtraSelection) {
        extra.quantity = Math.max(extra.quantity - 1, 0)
        this.updateTotal();
    }

    add(extra: ExtraSelection) {
        extra.quantity = Math.min(extra.quantity + 1, EXTRAS_MAX_QUANTITY)
        this.updateTotal();
    }

    updateTotal() {
        this.total = extrasTotalPrice(this.repo._order, this.extras);
    }

    async dismiss() {
        const order = this.repo._order;
        applyExtrasToOrder(order, this.extras);
        this.repo.onOrderChange(order);


        const result = await CheckoutModalComponent.show(this.modalCtrl, null, this.order, null);
        if (result.data === undefined) return;

        this.order.orderAt = result.data.orderAt;
        this.order.preorder = result.data.preorder;
        this.tip = result.data.tip;

        this.repository.onOrderChange(this.order);
        try {
            await this.repository.createOrderWithPayment(
                this.modalCtrl,
                this.translate,
                this.order,
                this.tip,
                loading => (this.loading = loading),
                this.snackbarCtrl,
                false,
                false,
                null
            );
        } catch (e) {
            console.log(JSON.parse(JSON.stringify(e)));
        }

        this.repo.onOrderChange(this.repo._order);
        this.modalCtrl.dismiss();
    }

    openMap() {
        this.modalCtrl.dismiss()
        this.navigationService.map()
    }


    protected readonly OrderUtils = OrderUtils;
    protected readonly numberToCurrency = numberToCurrency;
}
